var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "main" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("Menu.Payments")))]),
      _vm._v(" "),
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("Payments.Instructions")) }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-0" }, [
        _vm._v(_vm._s(_vm.$t("Payments.PaymentByType")))
      ]),
      _vm._v(" "),
      _vm.aidTargetPayments && _vm.aidTargetPayments.length > 0
        ? _c("payment-type-by-target-table", {
            attrs: { paymentData: _vm.aidTargetPayments }
          })
        : _c("div", { staticClass: "mb-4" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("Payments.PaymentsNoPaymentRequests")))
            ])
          ]),
      _vm._v(" "),
      _c("h2", { staticClass: "mt-4 mb-0" }, [
        _vm._v(_vm._s(_vm.$t("Payments.FuturePayments")))
      ]),
      _vm._v(" "),
      _vm.futurePayments && _vm.futurePayments.length > 0
        ? _c("payments-table", {
            attrs: {
              payments: _vm.futurePayments,
              title: _vm.$t("Payments.FuturePayments")
            }
          })
        : _c("div", { staticClass: "mb-4" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("Payments.NoFuturePayments")))])
          ]),
      _vm._v(" "),
      _c("h2", { staticClass: "mt-4 mb-0" }, [
        _vm._v(_vm._s(_vm.$t("Payments.PaymentHistory")))
      ]),
      _vm._v(" "),
      _vm.hasPaymentHistoryItems
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4 pull-left" },
              [
                _c("single-select-accessible", {
                  staticStyle: { "margin-top": "0!important" },
                  attrs: {
                    options: _vm.availableYears,
                    dropdownId: "historyYearSelection",
                    savable: false,
                    title: "Payments.SelectPaidYear",
                    omitPlaceholder: true,
                    doNotUseResources: true
                  },
                  model: {
                    value: _vm.selectedYear,
                    callback: function($$v) {
                      _vm.selectedYear = $$v
                    },
                    expression: "selectedYear"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-8 right pull-right" }, [
              !_vm.downloadingFile
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: {
                            content: _vm.$t("Payments.Btn_Excel_Description")
                          },
                          expression:
                            "{ content: $t('Payments.Btn_Excel_Description') }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.generateExcel()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("Payments.Btn_Excel")) +
                          "\n        "
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(
                          "-. " +
                            _vm._s(_vm.$t("Payments.Btn_Excel_Description"))
                        )
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: {
                            content: _vm.$t("Payments.Btn_Excel_Description")
                          },
                          expression:
                            "{ content: $t('Payments.Btn_Excel_Description') }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "d-inline-block",
                      attrs: { tabindex: "0" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: "",
                            "aria-disabled": true
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("Payments.Btn_Excel")) +
                              "\n          "
                          ),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(
                              "-. " +
                                _vm._s(_vm.$t("Payments.Btn_Excel_Description"))
                            )
                          ])
                        ]
                      )
                    ]
                  )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPaymentHistoryItemsForSelectedYear
        ? _c("payments-table", {
            key: _vm.tableRenderKey,
            attrs: {
              payments: _vm.yearlyPaymentHistory,
              isHistory: true,
              title: _vm.$t("Payments.PaymentHistory")
            }
          })
        : _c("div", { staticClass: "mb-4" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("Payments.NoPaymentHistory")))])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }